export default function (document = document, window = window) {
  [...document.querySelectorAll(".js-video-player__mount")].forEach(
    initVideoPlayer,
  );

  function initVideoPlayer(el, i) {
    const subtitles = el.dataset.videoSubtitles
      ? {
          tracks: [
            JSON.parse(el.dataset.videoSubtitles),
            {
              src: "",
              label: "None",
              is_default: false,
            },
          ],
        }
      : null;

    const customConfig = el.dataset.customConfig
      ? JSON.parse(el.dataset.customConfig)
      : null;

    const flowplayerConfig = {
      hls: {},
      src: el.dataset.videoSrc,
      token: el.dataset.videoToken,
      auto_orient: true,
    };

    if (subtitles) {
      flowplayerConfig.subtitles = subtitles;
    }

    const video = window.flowplayer(el, {
      ...flowplayerConfig,
      ...customConfig,
    });

    //flowplayer automatically adds these and won't remove them unless the user re-orients their device
    video.removeAttribute("playsinline");
    video.removeAttribute("webkit-playsinline");
  }
}
